import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class TypeunitpriceService {
  private apiUrl = '/typeunitprices';
  private apiSpringUrl = '/spring/typeunitprices';

  constructor(private http: HttpService) { }

  get(): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    return this.http.get(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/typeunitprice/typeunitprice.service.ts